export default "__VITE_ASSET__pDmZZixA__"